/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';

import {
  CHANNEL_PUBLISHING_HISTORY_DONE_FETCHING,
  CHANNEL_PUBLISHING_HISTORY_ERROR_FETCHING,
  CHANNEL_PUBLISHING_HISTORY_FETCHING,
  CLEAR_PUBLISHING_HISTORY,
  SET_PUBLISHING_HISTORY_QUERY_DATA,
  SET_PUBLISHING_HISTORY_CHANNEL_IDS,
  PUBLISHING_HISTORY_SET_CSV,
  PublishingHistoryActions
} from 'store/action/publishing-history';
import {IStartEnd} from 'interfaces/analyticsProps';
import {IPortalError} from 'utility/error-handler';

export interface IPublishingHistoryState {
  publishingHistory: Record<string, string>[];
  isFetching: boolean;
  error: null | IPortalError;
  csv: string;
  queryData: IStartEnd;
}

const initialState: IPublishingHistoryState = {
  publishingHistory: [],
  isFetching: false,
  error: null,
  csv: '',
  queryData: {
    start: new Date(),
    end: new Date()
  }
};
const publishingHistoryReducer: Reducer<
  Readonly<IPublishingHistoryState>,
  PublishingHistoryActions
> = (state: IPublishingHistoryState = initialState, action: PublishingHistoryActions) => {
  switch (action.type) {
    case CLEAR_PUBLISHING_HISTORY: {
      return {...initialState};
    }

    case SET_PUBLISHING_HISTORY_CHANNEL_IDS: {
      return {
        ...initialState,
        channelIDs: [...action.payload]
      };
    }

    case CHANNEL_PUBLISHING_HISTORY_FETCHING: {
      return {
        ...state,
        isFetching: true
      };
    }

    case PUBLISHING_HISTORY_SET_CSV: {
      return {
        ...state,
        csv: action.payload
      };
    }

    case CHANNEL_PUBLISHING_HISTORY_DONE_FETCHING: {
      return {
        ...state,
        isFetching: false,
        publishingHistory: action.payload,
        error: null
      };
    }

    case CHANNEL_PUBLISHING_HISTORY_ERROR_FETCHING: {
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    }

    case SET_PUBLISHING_HISTORY_QUERY_DATA: {
      return {
        ...state,
        queryData: {
          end: action.payload.end || state.queryData.end,
          start: action.payload.start
        }
      };
    }

    default:
      return state;
  }
};

export default publishingHistoryReducer;